export const ROUTE_LOGIN = "/signin";
export const LOGIN_WITH_ACCU = "/signin?accu=";
export const HELLO_WORLD = "/helloworld";
